/**
 * Registered on the plugin, so it shows up under Settings / Feature Flags and each
 * user can switch the preview on or off for themselves.
 */
export const AI_GATEWAY_KEYS_FEATURE_FLAG = 'ai-gateway-keys';
